import Vue from 'vue'
import VueRouter from 'vue-router'
import Feedback from '../views/Feedback.vue'
import Logout from '../views/Logout.vue'
import Privacy from '../views/Privacy.vue'
import User from '../views/User.vue'
import Home from '../views/Home.vue'
import Membercentre from '../views/Membercentre.vue'
import Member from '../views/Member.vue'
import SeedRecharge from '../views/SeedRecharge.vue'
import SeedRecord from '../views/SeedRecord.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: "专注ing"
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: Feedback,
    meta: {
      title: "lang.title.feedback"
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta: {
      title: "lang.title.logout"
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: {
      title: "lang.title.privacy"
    }
  },
  {
    path: '/user',
    name: 'user',
    component: User,
    meta: {
      title: "lang.title.user"
    }
  },
  {
    path: '/membercentre',
    name: 'membercentre',
    component: Membercentre,
    meta: {
      title: "lang.title.membercentre"
    }
  },
  {
    path: '/member',
    name: 'member',
    component: Member,
    meta: {
      title: "lang.title.member"
    }
  },
  {
    path: '/seedrecharge',
    name: 'seedRecharge',
    component: SeedRecharge,
    meta: {
      title: "lang.title.recharge"
    }
  },
  {
    path: '/seedrecord',
    name: 'seedRecord',
    component: SeedRecord,
    meta: {
      title: "lang.title.record"
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
